import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"

export const Section = styled(SectionWrapper)`
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  overflow: hidden;
  height: 810px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    border-radius: 0px 0px 40px 40px;
  }
`

export const Wrapper = styled(Container)`
  margin-top: ${({ theme }) => theme.typography.pxToRem(200)};
  position: relative;
`

export const BackgroundImage = styled(CustomBgImage)`
  position: relative;
  height: 810px;
`

export const Image = styled(CustomImage)`
  max-width: 1330px;
  width: 100%;
  position: absolute;
  bottom: -15px;
  right: 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    left: 0;
    width: 1000px !important;

    img {
      position: relative;
      height: 350px;
      width: 1000px !important;
      object-fit: cover !important;
    }
  }
`

export const TopTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.tertiary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.42px;
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(24)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    margin-bottom: 1rem;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem(48)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(60)};
  max-width: 690px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(32)};
    line-height: ${({ theme }) => theme.typography.pxToRem(40)};
    font-weight: 500;
  }
`
